import React from "react";
import { FIRMA, LOGO_URL } from "@/lib/branding";

export const CompanyLogo = ({ className = "h-12 w-12", initial = "" }) => {
  if (LOGO_URL) {
    return (
      <img
        src={LOGO_URL}
        alt="Logo"
        className={`${className} object-contain`}
        data-testid="brand-logo"
      />
    );
  }
  const letter = (initial || FIRMA.firma || FIRMA.name || "·").trim().charAt(0).toUpperCase() || "·";
  return (
    <div
      className={`${className} rounded-lg flex items-center justify-center font-bold text-white`}
      style={{ background: "var(--brand-primary)" }}
      data-testid="brand-logo"
    >
      <span className="text-lg">{letter}</span>
    </div>
  );
};
